"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BarChartReportGroup", {
  enumerable: true,
  get: function get() {
    return _BarChartReportGroup["default"];
  }
});
Object.defineProperty(exports, "ClientReportToolbar", {
  enumerable: true,
  get: function get() {
    return _ClientReportToolbar["default"];
  }
});
Object.defineProperty(exports, "ClientToolbar", {
  enumerable: true,
  get: function get() {
    return _ClientToolbar["default"];
  }
});
Object.defineProperty(exports, "DataCollection", {
  enumerable: true,
  get: function get() {
    return _DataCollection["default"];
  }
});
Object.defineProperty(exports, "FidelityReportGroup", {
  enumerable: true,
  get: function get() {
    return _FidelityReportGroup["default"];
  }
});
Object.defineProperty(exports, "FidelityReportTemplate", {
  enumerable: true,
  get: function get() {
    return _Fidelity["default"];
  }
});
Object.defineProperty(exports, "FidelitySingleGroupReportTemplate", {
  enumerable: true,
  get: function get() {
    return _FidelitySingleGroup["default"];
  }
});
Object.defineProperty(exports, "GroupBarChartAdapter", {
  enumerable: true,
  get: function get() {
    return _GroupBarChartAdapter["default"];
  }
});
Object.defineProperty(exports, "GroupFidelityAdapter", {
  enumerable: true,
  get: function get() {
    return _GroupFidelityAdapter["default"];
  }
});
Object.defineProperty(exports, "GroupLogAdapter", {
  enumerable: true,
  get: function get() {
    return _GroupLogAdapter["default"];
  }
});
Object.defineProperty(exports, "GroupOutcomesAdapter", {
  enumerable: true,
  get: function get() {
    return _GroupOutcomesAdapter["default"];
  }
});
Object.defineProperty(exports, "GroupProgressAdapter", {
  enumerable: true,
  get: function get() {
    return _GroupProgressAdapter["default"];
  }
});
Object.defineProperty(exports, "GroupTableReportAdapter", {
  enumerable: true,
  get: function get() {
    return _GroupTableReportAdapter["default"];
  }
});
Object.defineProperty(exports, "IndividualFidelityAdapter", {
  enumerable: true,
  get: function get() {
    return _IndividualFidelityAdapter["default"];
  }
});
Object.defineProperty(exports, "IndividualLogAdapter", {
  enumerable: true,
  get: function get() {
    return _IndividualLogAdapter["default"];
  }
});
Object.defineProperty(exports, "IndividualProgressAdapter", {
  enumerable: true,
  get: function get() {
    return _IndividualProgressAdapter["default"];
  }
});
Object.defineProperty(exports, "LineChartAdapter", {
  enumerable: true,
  get: function get() {
    return _LineChartAdapter["default"];
  }
});
Object.defineProperty(exports, "LineChartReport", {
  enumerable: true,
  get: function get() {
    return _LineChartReport["default"];
  }
});
Object.defineProperty(exports, "LogReport", {
  enumerable: true,
  get: function get() {
    return _LogReport["default"];
  }
});
Object.defineProperty(exports, "LogReportGroup", {
  enumerable: true,
  get: function get() {
    return _LogReportGroup["default"];
  }
});
Object.defineProperty(exports, "LogReportTemplate", {
  enumerable: true,
  get: function get() {
    return _Log["default"];
  }
});
Object.defineProperty(exports, "OutcomesGroupComparisonReportTemplate", {
  enumerable: true,
  get: function get() {
    return _OutcomesGroupComparison["default"];
  }
});
Object.defineProperty(exports, "OutcomesGroupReportTemplate", {
  enumerable: true,
  get: function get() {
    return _OutcomesGroup["default"];
  }
});
Object.defineProperty(exports, "OutcomesIndividualReportTemplate", {
  enumerable: true,
  get: function get() {
    return _OutcomesIndividual["default"];
  }
});
Object.defineProperty(exports, "OutcomesReport", {
  enumerable: true,
  get: function get() {
    return _OutcomesReport["default"];
  }
});
Object.defineProperty(exports, "PawnListProcessor", {
  enumerable: true,
  get: function get() {
    return _PawnList["default"];
  }
});
Object.defineProperty(exports, "ProgressReport", {
  enumerable: true,
  get: function get() {
    return _ProgressReport["default"];
  }
});
Object.defineProperty(exports, "ProgressReportGroup", {
  enumerable: true,
  get: function get() {
    return _ProgressReportGroup["default"];
  }
});
Object.defineProperty(exports, "SummaryFidelityAdapter", {
  enumerable: true,
  get: function get() {
    return _SummaryFidelityAdapter["default"];
  }
});
Object.defineProperty(exports, "SummaryReportToolbar", {
  enumerable: true,
  get: function get() {
    return _SummaryReportToolbar["default"];
  }
});
Object.defineProperty(exports, "TableReport", {
  enumerable: true,
  get: function get() {
    return _TableReport["default"];
  }
});
Object.defineProperty(exports, "TableReportAdapter", {
  enumerable: true,
  get: function get() {
    return _TableReportAdapter["default"];
  }
});
var _reducer = _interopRequireDefault(require("./reducer.js"));
var _DataCollection = _interopRequireDefault(require("./components/DataCollection"));
var _ClientToolbar = _interopRequireDefault(require("./components/ClientToolbar"));
var _ClientReportToolbar = _interopRequireDefault(require("./components/ClientReportToolbar"));
var _SummaryReportToolbar = _interopRequireDefault(require("./components/SummaryReportToolbar"));
var _FidelityReportGroup = _interopRequireDefault(require("./components/FidelityReportGroup"));
var _LogReport = _interopRequireDefault(require("./components/LogReport"));
var _LogReportGroup = _interopRequireDefault(require("./components/LogReportGroup"));
var _OutcomesReport = _interopRequireDefault(require("./components/OutcomesReport"));
var _ProgressReportGroup = _interopRequireDefault(require("./components/ProgressReportGroup"));
var _ProgressReport = _interopRequireDefault(require("./components/ProgressReport"));
var _LineChartReport = _interopRequireDefault(require("./components/LineChartReport"));
var _TableReport = _interopRequireDefault(require("./components/TableReport"));
var _BarChartReportGroup = _interopRequireDefault(require("./components/BarChartReportGroup"));
var _GroupLogAdapter = _interopRequireDefault(require("./components/adapters/GroupLogAdapter.js"));
var _GroupOutcomesAdapter = _interopRequireDefault(require("./components/adapters/GroupOutcomesAdapter.js"));
var _IndividualLogAdapter = _interopRequireDefault(require("./components/adapters/IndividualLogAdapter.js"));
var _GroupFidelityAdapter = _interopRequireDefault(require("./components/adapters/GroupFidelityAdapter.js"));
var _IndividualFidelityAdapter = _interopRequireDefault(require("./components/adapters/IndividualFidelityAdapter.js"));
var _IndividualProgressAdapter = _interopRequireDefault(require("./components/adapters/IndividualProgressAdapter.js"));
var _LineChartAdapter = _interopRequireDefault(require("./components/adapters/LineChartAdapter.js"));
var _TableReportAdapter = _interopRequireDefault(require("./components/adapters/TableReportAdapter.js"));
var _GroupTableReportAdapter = _interopRequireDefault(require("./components/adapters/GroupTableReportAdapter.js"));
var _GroupBarChartAdapter = _interopRequireDefault(require("./components/adapters/GroupBarChartAdapter.js"));
var _GroupProgressAdapter = _interopRequireDefault(require("./components/adapters/GroupProgressAdapter.js"));
var _SummaryFidelityAdapter = _interopRequireDefault(require("./components/adapters/SummaryFidelityAdapter.js"));
var _PawnList = _interopRequireDefault(require("./components/flowVarProcessors/PawnList.js"));
var _Fidelity = _interopRequireDefault(require("./reportTemplates/Fidelity"));
var _FidelitySingleGroup = _interopRequireDefault(require("./reportTemplates/FidelitySingleGroup"));
var _Log = _interopRequireDefault(require("./reportTemplates/Log"));
var _OutcomesGroup = _interopRequireDefault(require("./reportTemplates/OutcomesGroup"));
var _OutcomesGroupComparison = _interopRequireDefault(require("./reportTemplates/OutcomesGroupComparison"));
var _OutcomesIndividual = _interopRequireDefault(require("./reportTemplates/OutcomesIndividual"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// Report templates

// Inject flow reducer
var store = window.cccisd && window.cccisd.store;
if (store) {
  if (!store.getState().impact) {
    store.injectReducer('impact', _reducer["default"]);
  }
} else {
  console.error('There is no redux store at window.cccisd');
}